/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link, navigate } from "gatsby"
import { Helmet } from "react-helmet"
import Header from "./header"
import { Button, Col, Grid, Row } from "react-bootstrap"
import StrataDocumentsModal from "../pages/documents/strata-documents-modal"

const Layout = ({ children }) => {
  const strataPortalUrl = `${process.env.GATSBY_API_URL}/strataLogin`
  const residentialPortalUrl = `${process.env.GATSBY_API_URL}/login`
  const [currentForm, setCurrentForm] = useState("");
  const rentalManagementProposalRequest = 'rentalManagementProposalRequest'
  const strataProposalRequest = 'strataProposalRequest'
  const rentalManagementProposalRequestUrl = 'https://www.cognitoforms.com/f/W1oWZRgNeEyMzPEiawDi3Q/11'
  const strataProposalRequestUrl = 'https://www.cognitoforms.com/f/W1oWZRgNeEyMzPEiawDi3Q/10'

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  return (
    <>
      <Helmet>
      <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css"
            integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u"
            crossOrigin="anonymous" />
      </Helmet>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div className='margin-zero-auto'>
        <main>{children}</main>
      </div>
      <footer id="footer" className="custom-footer m-none">
        <Grid>
          <Row>
            <Col md={3} mdOffset={1}>
              <h5 className="text-color-light font-weight-bold mb-xs">Strata Management</h5>
              <ul>
                <li>
                  <Link to="/strata-management-services" className="text-color-light" title="Strata Management Services">
                    Strata Management Services
                  </Link>
                </li>
                  <li onClick={() => setCurrentForm(strataProposalRequest)} className="text-color-light" title="forms">
                    <Link to="#" className="text-color-light text-decoration-none" title="Strata Management Proposal Request">
                      Strata Management Proposal Request
                      <StrataDocumentsModal
                        open={currentForm===strataProposalRequest}
                        openModal={setCurrentForm}
                        documentUrl={strataProposalRequestUrl}/>
                    </Link>
                  </li>
                <li>
                  <Link to={strataPortalUrl} className="text-color-light" title="Login">
                    Strata Management Login
                  </Link>
                </li>
              </ul>
            </Col>
            <Col md={3} mdOffset={1}>
              <h5 className="text-color-light font-weight-bold mb-xs">Company</h5>
              <ul>
                <li>
                  <Link to="/company" className="text-color-light">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-color-light">
                    Contact
                  </Link>
                </li>
              </ul>
            </Col>
            <Col md={3} mdOffset={1}>
              <h5 className="text-color-light font-weight-bold mb-xs">Rental Management</h5>
              <ul>
                <li>
                  <Link to="/rental-management-services" className="text-color-light" title="Rental Management Services">
                    Rental Management Services
                  </Link>
                </li>
                  <li onClick={() => setCurrentForm(rentalManagementProposalRequest)} className="text-color-light" title="Rental Management Proposal Request">
                    <Link to="#" className="text-color-light text-decoration-none" title="Rental Management Proposal Request">
                      Rental Management Proposal Request
                      <StrataDocumentsModal
                        open={currentForm===rentalManagementProposalRequest}
                        openModal={setCurrentForm}
                        documentUrl={rentalManagementProposalRequestUrl}/>
                    </Link>
                  </li>
                <li>
                  <Link to={residentialPortalUrl} className="text-color-light" title="Login">
                    Rental Management Login
                  </Link>
                </li>
              </ul>
            </Col>
          </Row>
        </Grid>
        <div className="footer-copyright m-none pt-md pb-md">
          <Grid>
            <Row>
              <Col md={12} className="pt-md center">
                <p className="custom-text-color-2">&copy; Copyright 2022 Korecki Real Estate Services Inc. All Rights Reserved.</p>
              </Col>
            </Row>
          </Grid>
        </div>
      </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
